import React, { useCallback } from "react";
import * as Constants from "../../constants";
import {
  useHistory,
  withRouter,
  Switch,
  useRouteMatch,
} from "react-router-dom";
import ContentTable from "./ContentTable";
import SchedaRespComm from "../Forms/SchedaRespComm";
import { PrivateRoute } from "../../../App";

function ResponsabiliCommessa(props) {
  const { url, path } = useRouteMatch();

  const history = useHistory();

  const changeRoute = useCallback(
    (row) => {
      console.log(row.nome);
      history.push({ pathname: url + "/" + row.nome, state: row });
    },
    [url, history]
  );
  const changeState = useCallback(
    (row) => {
      history.push({pathname: "/"});
      history.replace({ pathname: url + "/" + row.nome, state: row });
    },
    [url, history]
   );

  const backFromScheda = useCallback(() => {
    history.push({ pathname: "/Responsabili Commessa" });
  }, [history]);

  const columns = React.useMemo(
    () => [
      {
        Header: "Id",
        accessor: "personaId", // accessor è la chiave in data
      },
      {
        Header: "Nome",
        accessor: "nome",
      },
      {
        Header: "Cognome",
        accessor: "cognome",
      },
      {
        Header: "Email",
        accessor: "email",
      },
      {
        Header: "Pec",
        accessor: "pec",
      },
    ],
    []
  );

  return (
    <Switch>
      <PrivateRoute exact path="/Responsabili Commessa">
        <ContentTable
          columns={columns}
          title="Responsabili Commessa"
          fetchUrl={Constants.GETRESPCOMMURL}
          changeRoute={changeRoute}
          defaultOrderBy={"cognome"}
        />
      </PrivateRoute>
      <PrivateRoute
        exact
        path={"/Responsabili Commessa/Nuovo Responsabile Commessa"}
      >
        <SchedaRespComm
          backFromScheda={backFromScheda}
          changeState={changeState}
          nuovaScheda={true}
        />
      </PrivateRoute>
      <PrivateRoute exact path={"/Responsabili Commessa/:nome"}>
        <SchedaRespComm
          backFromScheda={backFromScheda}
          nuovaScheda={false}
        />
      </PrivateRoute>
    </Switch>
  );
}

export default withRouter(ResponsabiliCommessa);
